import config from '../config';

const _storage = localStorage;
const _identifier = config.lang.LANGUAGE_IDENTIFIER;

export default {

    /**
     * Get the chosen language value from storage. If none selected then return default value.
     *
     * @returns {string | null}
     */
    getLanguageFromStorage() {
        return _storage.getItem(_identifier)
    },

    /**
     * Save the chosen language in storage.
     *
     * @param language
     */
    setLanguageInStorage(language) {
        _storage.setItem(_identifier, language)
    }
}


// WEBPACK FOOTER //
// ./src/services/LanguageService.js